
  import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

  @Component
  export default class General extends Vue  {
      dialog =  false
      loading = false
      headers = [
        {
          text: 'Message',
          align: 'start',
          value: 'message',
        },
        { text: 'Date', value: 'created_at' },
      ]

      @Prop() readonly type!: string
      @Prop() readonly item!: any

      public close(): void {
        this.$store.commit('bridge/setLogs', [])
        this.dialog = false
      }

      //getters
      get getLogs(): boolean {
        return this.$store.getters['bridge/getLogs']
      }

      @Watch('dialog')
      async getLogType(val: any) {
        this.loading = true
        if(val) {
          await this.$store.dispatch('bridge/getBridgeLogs', {
            'id': this.item.id,
            'type': this.type
          })
          this.dialog = true
          this.loading = false

        }
      }
  }
